export const doesIncludeSubstring = (a: string = '', b: string = '') => a.toLowerCase().includes(b.toLowerCase());
